import axios from 'axios';
const apiUrl = process.env.REACT_APP_PANEL_URL;

export const searchAndGetTemplate = (templateId, allTemplates) => {
  const foundTemplate = allTemplates.find((template) => template.id === templateId);
  return foundTemplate ? foundTemplate.message : templateId;
};

export const handleResetContext = async ({ token, chatId, infoRoute, projectId, sessionId }) => {
  const url = apiUrl + infoRoute;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      Authorization: `bearer ${token}`,
    },
    data: JSON.stringify({ chatId, projectId, sessionId }),
  };
  const response = await axios(url, requestOptions);
  return response;
};
